import { createFileRoute } from '@tanstack/react-router';
import { CreateIndividualContractPage } from '@/pages/contract/individual-contract/create-individual-contract-page.tsx';

export const Route = createFileRoute('/_auth/einzelvertrag/anlegen/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CreateIndividualContractPage />;
}
